const PREFIX = "CreateDataset";
export const SET_S3_FETCH_PROGRESS = `${PREFIX}_SET_S3_FETCH_PROGRESS`;
export const SET_PREVIEW_DATA = `${PREFIX}_SET_PREVIEW_DATA`;
export const SET_PREVIEW_DATA_SOURCE = `${PREFIX}_SET_PREVIEW_DATA_SOURCE`;
export const SET_NEW_DATASET = `${PREFIX}_SET_NEW_DATASET`;
export const SET_IS_LOADING = `${PREFIX}_SET_IS_LOADING`;
export const SET_ACTIVITY_LOGS = `${PREFIX}_SET_ACTIVITY_LOGS`;
export const RESET_STORE = `${PREFIX}_RESET_STORE`;
export const SET_IMAGE_ERROR_FILE_NAME = `${PREFIX}_SET_IMAGE_ERROR_FILE_NAME`;
export const SET_ACTIVITY_OFFSET = `${PREFIX}_SET_ACTIVITY_OFFSET`;
export const SET_IS_FATAL_ERROR = `${PREFIX}_SET_IS_FATAL_ERROR`;
export const SET_FILES_UPLOAD_TRANS_ID = `${PREFIX}_SET_FILES_UPLOAD_TRANS_ID`;
export const SET_LIMIT_EXCEEDED_DETAILS = `${PREFIX}_SET_LIMIT_EXCEEDED_DETAILS`;

export const SET_UPLOAD_STATUS = `${PREFIX}_SET_UPLOAD_STATUS`;
export const SET_CONNECT_STATUS = `${PREFIX}_SET_CONNECT_STATUS`;
export const SET_INDEXING_STATUS = `${PREFIX}_SET_INDEXING_STATUS`;
export const SET_ANNOTATION_STATUS = `${PREFIX}_SET_ANNOTATION_STATUS`;

export const SET_ARE_ANNOTATIONS_FETCHED = `${PREFIX}_SET_ARE_ANNOTATIONS_FETCHED`;
export const SET_STATUS_CALL_IN_PROGRESS = `${PREFIX}_SET_STATUS_CALL_IN_PROGRESS`;
export const SET_SHOW_ACTIVITY_LOG_MODAL = `${PREFIX}_SET_SHOW_ACTIVITY_LOG_MODAL`;

export const SET_LAST_USED_DATA = `${PREFIX}_SET_LAST_USED_DATA`;
export const SET_UPLOAD_FINISHED = `${PREFIX}_SET_UPLOAD_FINISHED`;
export const SET_USER_INITIATED_CREATION = `${PREFIX}_SET_USER_INITIATED_CREATION`;
export const SET_FILES_UPLOAD_SIZE = `${PREFIX}_SET_FILES_UPLOAD_SIZE`;
export const SET_FILES_UPLOAD_PROGRESS = `${PREFIX}_SET_FILES_UPLOAD_PROGRESS`;

export const SET_CVAT_DATA = `${PREFIX}_SET_CVAT_DATA`;
export const SET_IS_CVAT_LOADING = `${PREFIX}_SET_IS_CVAT_LOADING`;

// New Dataset Creation Workflow
export const SET_FOLDER_UPLOAD_STATUS = `${PREFIX}_SET_FOLDER_UPLOAD_STATUS`;
export const SET_UPLOADING_FOLDER = `${PREFIX}_SET_UPLOADING_FOLDER`;
export const SET_MULTI_FOLDER_UPLOAD = `${PREFIX}_SET_MULTI_FOLDER_UPLOAD`;
export const UPDATE_MULTI_FOLDER_PROGRESS = `${PREFIX}_UPDATE_MULTI_FOLDER_PROGRESS`;
export const SET_FOLDERS_METADATA = `${PREFIX}_SET_FOLDERS_METADATA`;
export const SET_PREVIEWS = `${PREFIX}_SET_PREVIEWS`;
export const SET_PREVIEWS_LOADING = `${PREFIX}_SET_PREVIEWS_LOADING`;
export const SET_FOLDER_METADATA_POLLING = `${PREFIX}_SET_FOLDER_METADATA_POLLING`;
export const SET_LOCAL_FOLDER_SELECTIONS = `${PREFIX}_SET_LOCAL_FOLDER_SELECTIONS`;
export const SET_INVALID_FOLDERS = `${PREFIX}_SET_INVALID_FOLDERS`;
export const SET_VALIDATION_LOADING = `${PREFIX}_SET_VALIDATION_LOADING`;
// Dataset Processing
export const SET_CREATION_STATUS = `${PREFIX}_SET_CREATION_STATUS`;
export const SET_CREATION_STATUS_POLLING = `${PREFIX}_SET_CREATION_STATUS_POLLING`;

// Resource Configuration
export const SET_RESOURCE_CONFIGURATION = `${PREFIX}_SET_RESOURCE_CONFIGURATION`;
export const RESET_RESOURCE_CONFIGURATION = `${PREFIX}_RESET_RESOURCE_CONFIGURATION`;
export const SET_SHOW_RESOURCE_CONFIGURATION_MODAL = `${PREFIX}_SET_SHOW_RESOURCE_CONFIGURATION_MODAL`;
